import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

//declarated component
import { EditDatasheetSectionComponent } from './edit-datasheet-section.component';

//internal modules
import { EditButtonModule } from 'src/app/views/shared/components/buttons/edit-button/edit-button.module';
import { SpinnerModule } from 'src/app/views/shared/components/spinner/spinner.module';



@NgModule({
  declarations: [
    EditDatasheetSectionComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    //internal modules
    EditButtonModule,
    SpinnerModule,
  ],
  exports: [
    EditDatasheetSectionComponent
  ]
})
export class EditDatasheetSectionModule { }
